import { render, staticRenderFns } from "./recipient-filter-control.vue?vue&type=template&id=41895b4d&scoped=true&"
import script from "./recipient-filter-control.vue?vue&type=script&lang=js&"
export * from "./recipient-filter-control.vue?vue&type=script&lang=js&"
import style0 from "./recipient-filter-control.vue?vue&type=style&index=0&id=41895b4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41895b4d",
  null
  
)

export default component.exports